import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { ReportsResponse } from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useReports = (page: number = 1, perPage: number = 20) => {
  const fetchWithAuth = useFetchWithAuth()

  const getReports: QueryFunction<ReportsResponse> = async () => {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString(),
    })

    const response = await fetchWithAuth(`${URL}/reports?${params}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })

    return response
  }

  return useQuery({
    queryKey: ['reports', page, perPage] as const,
    queryFn: getReports,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
